<template>
  <div class="s-contact p-cta">

    <div class="s-contact-head">
      <h3 class="f-xs">Office Locations</h3>
    </div>

    <div class="s-contact-wrap">
      <h2 class="f-xl">New York</h2>
      <h2 class="f-xl">London</h2>
    </div>

     <div class="s-contact-blocks">

      <div class="s-contact-block">
        <p class="f-xs">VR Advisory Services (USA) LLC</p>
        <p class="f-xs">
          601 Lexington Avenue
          <br />59th Floor
          <br />New York, NY 10022
          <br />Phone: +1 646 571 1870
        </p>
        <ul class="f-xs">
          <!-- <li>1 VR Advisory Services (USA) LLC has been regulated by the USA Financial Conduct Authority since July 2014.</li> -->
          <!-- <li><a class="l-rg" target="_blank" href="pdf/vr-annual-2019.pdf">2 VR Advisory Services (UK) LLP - MiFID II Annual Best Execution Disclosure 2019</a></li> -->
        </ul>
      </div>

      <div class="s-contact-block">
        <p class="f-xs">VR Advisory Services (UK) LLP</p>
        <p class="f-xs">
          The Kensington Building
          <br />1 Wrights Lane
          <br />4th Floor 
          <br />London, W8 5RY
          <br />Phone: +44 20 3761 9625
        </p>
        <ul class="f-xs">
          <li>1 VR Advisory Services (UK) LLP has been regulated by the UK Financial Conduct Authority since July 2014.</li>
        </ul>
      </div>

    </div>
    <div class="s-contact-image-container">
      <div class="s-contact-image"></div>
      <div class="s-contact-image"></div>
    </div>

    <div class="s-contact-inquiries">
      <p class="f-xs" data-animate="fade">
        General Inquiries:<br>
        Mr. Thomas Ginakakis: <a href="tel:0016465711870">Tel. +1 646 571 1870</a>
      </p>
    </div>

  </div>
</template>

<script>
import Contact from './contact';

let contact;

export default {
  mounted() {
    contact = new Contact();
    contact.init();
  },
  destroyed() {
    contact.destroy();
  },
};
</script>
